import { render } from "./ResearchSection.vue?vue&type=template&id=56de328c&scoped=true"
import script from "./ResearchSection.vue?vue&type=script&lang=js"
export * from "./ResearchSection.vue?vue&type=script&lang=js"

import "./ResearchSection.vue?vue&type=style&index=0&id=56de328c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56de328c"]])

export default __exports__